export default {
    combinedFuturesChart: {
        title: 'Fig C · Kombinirana futures pozicija (BASE + PEAK + OFF_PEAK)',
        subtitle: 'Referenca — ukupno složeno po intervalu',
        ariaLabel:
            'Grafikon složenih površina: BASE donji sloj 1 MW ravno, PEAK 2.5 MW složeno tijekom 08:00–20:00, OFF_PEAK 0.8 MW složeno tijekom bokova. Ukupno = kombinirana futures prilagodba po intervalu.',
        baseLabel: 'BASE ({mw} MW)',
        peakLabel: 'PEAK ({mw} MW · 08:00–20:00)',
        offPeakLabel: 'OFF_PEAK ({mw} MW · bokovi)',
    },
}
